import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { environment } from '@environments/environment';

@Injectable({ providedIn: 'root' })
export class StaticPageService {
    constructor(private http: HttpClient) { }

    getPage(params): Observable<any> {
        return this.http.get<any>(`${environment.apiUrl}/static-pages/${params}`);
    }
}